// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3NR9_","footer":"ModalInfo_footer__1ioMM"};